// Identidade visual do sistema
import { OBRASUL_LOGO_DATA_URL } from "./obrasulLogo";

export const BRAND = {
  name: "OBRASUL-RJ",
  tagline: "Obra Padrão · Sistema de Gestão de Obras",
  fullName: "OBRASUL-RJ · Obra Padrão · Sistema de Gestão de Obras",
  // Logo embebido em base64 (utilizado nos PDFs)
  logoDataUrl: OBRASUL_LOGO_DATA_URL,
  // Logo público (usado em <img> via path estático, mantém compatibilidade)
  logoUrl: "/brand/obrapadrao-logo.jpeg",
  // Cores oficiais
  colors: {
    navy: "#0A1628",
    gold: "#D4A437",
    cream: "#F5EFE3",
  },
};
